@let filteredAllowedChannelListingMappingsValue = listingChannelComparisonService.filteredAllowedChannelListingMappings();
<div class="cardContent" [formGroup]="userPreferencesForm">
    @if (filteredAllowedChannelListingMappingsValue?.length === 0) {
        <p>{{ 'listings.userPreferences.channelComparison.noChannels' | translate }}</p>
    } @else {
        <app-data-grid
            class="channelComparisonTable"
            [data]="listingChannelComparisonService.channelSnapshots()"
            [columns]="channelComparisonColumns"
        />
    }
</div>
